/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
import Button from '@cloudscape-design/components/button';
import { FC, PropsWithChildren, useCallback } from 'react';

export interface CopyToClipbordProps {
  /**
   * Specifies the text content to be copied instead of what is inside the children.
   */
  content?: string;
}

const CopyToClipbord: FC<PropsWithChildren<CopyToClipbordProps>> = ({ children, content }) => {
  const handleClick = useCallback(async () => {
    if (content) {
      await navigator.clipboard.writeText(content);
    } else if (typeof children === 'string') {
      await navigator.clipboard.writeText(children);
    }
  }, [children, content]);

  return <><Button iconName="copy" onClick={handleClick} variant="inline-icon" />{children}</>;
};

export default CopyToClipbord;